import styled, { keyframes } from 'styled-components';

import { DetailPanel } from 'components';

const shipPanelAppear = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

/**
 * Overrides DetailPanel's default centered-bottom position
 * to top-left corner, matching the original ship panel.
 */
export const ShipDetailPanel = styled(DetailPanel)`
  top: 20px !important;
  left: 20px !important;
  bottom: auto !important;
  right: auto !important;
  transform: none !important;
  width: auto;
  min-width: 0px !important;
  max-width: none !important;
  animation: ${shipPanelAppear} 0.25s ease-out !important;

  /* Blue corner accents */
  .corner {
    border-color: rgba(100, 150, 255, 0.6) !important;
  }

  /* Ship badge: transparent, no border, larger text */
  .detail-badge {
    width: 100% !important;
    border: none !important;
    color: rgba(150, 200, 255, 0.9) !important;
    background: transparent !important;
    font-size: 18px !important;
    padding: 6px 0 !important;
    height: auto !important;
    text-shadow: 0 0 10px rgba(100, 150, 255, 0.4) !important;
  }

  @media (max-width: 600px) {
    width: auto;
    min-width: 0px !important;
    max-width: none !important;
    left: 10px !important;
    top: 10px !important;
  }
`;

export const StatsRow = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: none;
  padding-bottom: 0;
  margin-bottom: 0;

  @media (max-width: 500px) {
    justify-content: center;
    gap: 15px;
  }
`;

export const StatSection = styled.div<{ $withBorder?: boolean }>`
  flex: 1;
  text-align: center;
  border: none;
  padding: 0 8px;

  ${({ $withBorder }) =>
    $withBorder &&
    `
    border-left: 1px solid rgba(100, 150, 255, 0.2);
  `}
`;

export const Label = styled.label`
  font-size: 12px !important;
  color: rgba(150, 200, 255, 0.9) !important;

  @media (max-width: 600px) {
    font-size: 10px !important;
  }
`;

export const Value = styled.div`
  color: #4da6ff !important;
  text-shadow: 0 0 10px rgba(77, 166, 255, 0.4);
  font-family: 'Rajdhani', sans-serif !important;
  font-size: 29px !important;
  font-weight: 600 !important;

  @media (max-width: 500px) {
    font-size: 19px !important;
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(100, 150, 255, 0.2);

  @media (max-width: 768px) {
    gap: 8px;
    margin-top: 8px;
    padding-top: 8px;
  }

  @media (max-width: 500px) {
    flex-direction: column;
    gap: 6px;
    margin-top: 8px;
    padding-top: 8px;
  }
`;

export const CopiedWalletsLabel = styled.div`
  font-family: 'Share Tech Mono', monospace;
  font-size: 11px;
  letter-spacing: 2px;
  color: rgba(255, 255, 255, 0.5);
  text-align: center;

  span {
    font-size: 13px;
    color: #4da6ff;
  }

  @media (max-width: 500px) {
    font-size: 9px;

    span {
      font-size: 10px;
    }
  }
`;

export const ActionsButtons = styled.div`
  display: flex;
  gap: 10px;

  @media (max-width: 500px) {
    gap: 6px;
  }
`;
